import {AwpDmsInterfaceFactoryUtils} from '../../rest-api/awp-dms-interface-factory-utils';
import {SearchCustomersRequest} from './search-customers-request';
import {SearchCustomersRequestBody} from './search-customers-request-body';
import {SearchCustomersFilter} from './search-customers-filter';

export class AwpDmsInterfaceSearchCustomersRequestFactory {
  createRequest(searchFilter: SearchCustomersFilter, resultPartition: number, vehicleResultPartition: number, locale: string, dpNo: string, outletNo: string): SearchCustomersRequest {
    const schema = 'awp-dms-search-customers-request';
    const version = '1.0.0';
    const request = new SearchCustomersRequest();
    request.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeaderFromPrimitives(dpNo, outletNo);
    request.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(schema, version);
    request.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformationFromPrimitive(locale);
    request.body = this.createRequestBody(searchFilter, resultPartition, vehicleResultPartition);
    return request;
  }

  private createRequestBody(searchFilter: SearchCustomersFilter, resultPartition?: number, vehicleResultPartition?: number): SearchCustomersRequestBody {
    const body = new SearchCustomersRequestBody();
    body.searchFilter = searchFilter;
    if (resultPartition != null) {
      body.resultPartition = resultPartition;
    }
    if (vehicleResultPartition != null) {
      body.vehicleResultPartition = vehicleResultPartition;
    }
    return body;
  }
}
